import API from './API.ts';
/**
 * SCR / Camping Key Europe (CKE) Service
 *
 * Alla endpoints är prefixade med /api/scr på servern.
 * Klienten använder relativ URL eftersom axios baseURL redan pekar på /api.
 */
export default {
    setup(payload) {
        return API.httpClient.post('scr/setup', payload);
    },
    //
    // Status
    //
    getStatus() {
        return API.httpClient.get('scr/status');
    },
    //
    // Sökning (bokningsflöde)
    //
    search(query) {
        return API.httpClient.get('scr/search', { params: { query } });
    },
    //
    // Direkt SCR-sökning (admin-sida)
    //
    searchSCR(query) {
        return API.httpClient.get('scr/search-scr', { params: { query } });
    },
    //
    // Kortstatus
    //
    getCardStatus(cardNumber) {
        return API.httpClient.get(`scr/card/${cardNumber}/status`);
    },
    //
    // Kontaktinfo från SCR
    //
    getCardContact(cardNumber) {
        return API.httpClient.get(`scr/card/${cardNumber}/contact`);
    },
    //
    // Skapa nytt CKE-kort
    //
    createCard(payload) {
        return API.httpClient.post('scr/card/create', payload);
    },
    //
    // Förläng kort
    //
    extendCard(cardNumber) {
        return API.httpClient.post(`scr/card/${cardNumber}/extend`);
    },
    //
    // Skicka om kort (e-post + SMS)
    //
    resendCard(cardNumber) {
        return API.httpClient.post(`scr/card/${cardNumber}/resend`);
    },
    //
    // Uppdatera SCR-kontaktinfo (ändrar BARA SCR-data, inte lokal kund)
    //
    updateCardContact(cardNumber, payload) {
        return API.httpClient.post(`scr/card/${cardNumber}/update`, payload);
    },
    //
    // Koppla CKE-kort till CampingOnline-kund
    //
    linkCustomer(payload) {
        return API.httpClient.post('scr/link-customer', payload);
    },
    //
    // Koppla bort CKE-kort från CampingOnline-kund
    //
    unlinkCustomer(payload) {
        return API.httpClient.post('scr/unlink-customer', payload);
    },
    //
    // Hämta CKE-kort kopplat till en kund
    //
    getCustomerCard(customerId) {
        return API.httpClient.get(`scr/customer/${customerId}/card`);
    },
    //
    // Manuell check-in (normalt automatiskt via observer)
    //
    checkin(payload) {
        return API.httpClient.post('scr/checkin', payload);
    },
    //
    // Manuell check-out (normalt automatiskt via observer)
    //
    checkout(payload) {
        return API.httpClient.post('scr/checkout', payload);
    }
};
